import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { MdClose, MdOutlineFileUpload } from 'react-icons/md';
import Modal from '../../components/modal';
import Input from '../../components/Input';

const PushNotifications = ({ isModalOpen, setIsModalOpen, closeModal }) => {
  const [planData, setPlanData] = useState({
    name: '',
    description: ''
  });

  const [loading, setLoader] = useState(false);
  const [category, setCategory] = useState([]);

  const isFormValid = () => {
    return planData.name && planData.description;
  };

  useEffect(() => {
    const requestOptions = {
      method: 'GET',
      redirect: 'follow'
    };

    fetch('https://quran-backend-theta.vercel.app/v1/admin/category', requestOptions)
      .then((response) => response.text())
      .then((result) => {
        let data = JSON.parse(result);
        setCategory(data?.data);
      })
      .catch((error) => {
        console.error(error);
      });
  }, [planData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setPlanData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const uploadAdditionalImages = async (files) => {
    const uploadedUrls = [];
    for (const file of files) {
      const formdata = new FormData();
      formdata.append('images', file);

      const requestOptions = {
        method: 'POST',
        body: formdata,
        redirect: 'follow'
      };

      try {
        const response = await fetch(
          'https://file-upload-ashen.vercel.app/api/upload',
          requestOptions
        );
        const result = await response.text();
        const data = JSON.parse(result);
        if (data?.success === true) {
          uploadedUrls.push(data?.data[0]);
        } else {
          toast.error('Error uploading additional images');
          return null;
        }
      } catch (error) {
        console.error(error);
        toast.error('Error uploading additional images');
        return null;
      }
    }
    return uploadedUrls;
  };

  const bannerSubmit = async (e) => {
    e.preventDefault();
    setLoader(true);

    // Upload main image
    const formdata = new FormData();
    formdata.append('images', planData.file);

    const requestOptions = {
      method: 'POST',
      body: formdata,
      redirect: 'follow'
    };

    try {
      const response = await fetch(
        'https://file-upload-ashen.vercel.app/api/upload',
        requestOptions
      );
      const result = await response.text();
      const data = JSON.parse(result);

      if (data?.success === true) {
        // Upload additional images
        const additionalImageUrls = await uploadAdditionalImages(planData.additionalImages);
        if (!additionalImageUrls) {
          setLoader(false);
          return;
        }

        const myHeaders = new Headers();
        myHeaders.append('Content-Type', 'application/json');
        myHeaders.append('Accept', 'application/json');
        myHeaders.append('Access-Control-Allow-Origin', '*');
        myHeaders.append('Authorization', `Bearer ${localStorage.getItem('token')}`);

        const raw = JSON.stringify({
          name: planData?.name,
          duration: Number(planData?.courseDuration),
          periodType: planData?.timePeriod,
          description: planData?.description,
          category: planData?.category,
          youtubeVideoLink: planData?.youtubeVideoLink,
          image: data?.data[0],
          price: Number(planData?.price),
          lesson: planData?.lessons,
          bulletPoints: planData?.bulletPoints, // Include bullet points
          additionalImages: additionalImageUrls // Include additional image URLs
        });

        const requestOptions = {
          method: 'POST',
          headers: myHeaders,
          body: raw,
          redirect: 'follow'
        };

        const courseResponse = await fetch(
          'https://quran-backend-theta.vercel.app/v1/admin/course',
          requestOptions
        );
        const courseResult = await courseResponse.text();
        const courseData = JSON.parse(courseResult);

        if (courseData?.success === false) {
          if (courseData?.message === 'Expired') {
            localStorage.clear();
            window.location.reload();
          } else {
            toast.error(courseData?.message);
          }
        } else {
          toast.success('Course added successfully!');
          window.location.reload();
        }
      } else {
        toast.error('Error uploading main image');
      }
    } catch (error) {
      console.error(error);
      toast.error('An error occurred');
    } finally {
      setLoader(false);
    }
  };

  return (
    <div>
      <Modal isOpen={isModalOpen} onClose={closeModal}>
        <div className="p-3 flex justify-between items-center">
          <span></span>
          <h1 className="capitalize h4 font-medium">Mass Push Notification</h1>
          <MdClose onClick={() => setIsModalOpen(false)} size={25} />
        </div>
        <hr />
        <div className="p-5">
          <form onSubmit={bannerSubmit}>
            <div className="flex gap-5 flex-wrap">
              <div className="w-full">
                <Input
                  label={'Subject'}
                  placeholder={'Subject'}
                  className={'bg-gray-100 px-2 w-full'}
                  name="subject"
                  value={planData.name}
                  onChange={handleChange}
                />
              </div>

              <div className="w-[100%]">
                <label>Description</label>
                <textarea
                  rows={5}
                  className="w-full bg-[#F6F6F6] py-3 px-5"
                  name="description"
                  onChange={handleChange}
                ></textarea>
              </div>
            </div>

            {loading ? (
              <button
                disabled
                type="button"
                className="bg-primary w-full text-center mt-3 py-2.5 rounded-lg text-white font-semibold cursor-pointer"
              >
                Loading...
              </button>
            ) : (
              <button
                type="submit"
                className={`w-full mt-3 bg-primary py-2.5 rounded-md text-white text-sm font-medium ${
                  !isFormValid() && 'cursor-not-allowed opacity-50'
                }`}
                disabled={!isFormValid()}
              >
                Submit
              </button>
            )}
          </form>
        </div>
      </Modal>
    </div>
  );
};

export default PushNotifications;
